export default "__VITE_ASSET__b3bb88b8__"